/**
 * DataMaturityBanner (#1184 v2.569.0) — kontextabhängiger Reife-Hinweis.
 *
 * Wird oben auf jeder Investor-Segment-Page + EBITDA-Wasserfall + Audit gerendert.
 * Werte siehe utils/data-maturity.js → evaluateMaturityBanner().
 */
import { AlertTriangle, AlertCircle, Info } from 'lucide-react';
import { evaluateMaturityBanner } from '../../../utils/data-maturity';

const STYLES = {
  red:   { bg: 'bg-red-50',     border: 'border-red-200',     text: 'text-red-800',     iconColor: '#DC2626', Icon: AlertTriangle },
  amber: { bg: 'bg-amber-50',   border: 'border-amber-200',   text: 'text-amber-800',   iconColor: '#D97706', Icon: AlertCircle },
  info:  { bg: 'bg-[#EBF5FD]',  border: 'border-[#338edc]/30',text: 'text-[#1A1A2E]',   iconColor: '#338edc', Icon: Info },
};

export default function DataMaturityBanner({ periodState, today = undefined, className = '' }) {
  const banner = evaluateMaturityBanner(periodState, today || new Date());
  if (!banner) return null;
  const style = STYLES[banner.level] || STYLES.info;
  const { Icon } = style;
  return (
    <div className={`${style.bg} ${style.border} border ${style.text} text-sm px-3 py-2.5 rounded-lg flex items-start gap-2.5 ${className}`}>
      <Icon width={16} height={16} stroke={style.iconColor} strokeWidth={2} fill="none" className="mt-0.5 shrink-0" />
      <div>
        <div className="font-semibold text-[13px]">{banner.title}</div>
        <div className="text-[12px] mt-0.5 leading-relaxed opacity-90">{banner.message}</div>
      </div>
    </div>
  );
}
